'use client'

const CriticalResourcePreloader = () => {
  return (
    <>      
      {/* Preload critical images */}
      <link
        rel="preload"
        href="/assets/image/hero.jpg"
        as="image"
        crossOrigin=""
      />
      
      {/* DNS prefetch for external domains */}
      <link rel="dns-prefetch" href="//www.youtube-nocookie.com" />
      <link rel="dns-prefetch" href="//vimeo.com" />
      
      {/* Preconnect for critical third-party resources */}
      <link rel="preconnect" href="//fonts.googleapis.com" />
      <link rel="preconnect" href="//fonts.gstatic.com" crossOrigin="" />
      
      {/* Security headers */}
      <meta httpEquiv="X-Frame-Options" content="DENY" />
      <meta httpEquiv="X-Content-Type-Options" content="nosniff" />
      <meta name="referrer" content="strict-origin-when-cross-origin" />
      
      {/* Performance hints */}
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
    </>
  );
};

export default CriticalResourcePreloader;